import { FC, useState } from 'react';
import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';
import { IListCheckCandidate } from 'src/ts/interfaces/listCheck';
import { ListCheckModalList } from '../../styles';
import ListCheckNoteField from './ListCheckNoteField';
import { listCheckCopy } from './listCheckCopy';

interface NoneOfTheseModalProps {
  displayName: string;
  candidates: IListCheckCandidate[];
  isLoading: boolean;
  requireNote?: boolean;
  onConfirm: (note?: string) => void;
  onCancel: () => void;
}

const NoneOfTheseModal: FC<NoneOfTheseModalProps> = ({
  displayName,
  candidates,
  isLoading,
  requireNote = false,
  onConfirm,
  onCancel
}) => {
  const [note, setNote] = useState('');
  return (
    <Modal
      title={candidates.length ? listCheckCopy.modalTitle : listCheckCopy.noMatchModalTitle}
      showModal
      variant={ModalVariant.danger}
      labelButtonConfirm={listCheckCopy.modalConfirm}
      labelButtonCancel={listCheckCopy.modalCancel}
      isLoadingButtonConfirm={isLoading}
      isDisabledButtonConfirm={isLoading || (requireNote && !note.trim())}
      isDisabledButtonCancel={isLoading}
      isBackClosable={!isLoading}
      onConfirm={() => onConfirm(requireNote ? note.trim() : undefined)}
      onCancel={onCancel}
      data-testid="list-check-none-of-these-modal"
    >
      {candidates.length > 0 && (
        <>
          <Text color={TextColor.gray600} variant={TextVariant.normal}>
            {listCheckCopy.modalLead(candidates.length, displayName)}
          </Text>
          <ListCheckModalList>
            {candidates.map((candidate, index) => (
              <li key={candidate.row_id ?? index}>
                {[candidate.label, candidate.row_ref].filter(Boolean).join(', ')}
              </li>
            ))}
          </ListCheckModalList>
        </>
      )}
      <Text color={TextColor.gray600} variant={TextVariant.normal}>
        {listCheckCopy.modalRecord}
      </Text>
      {candidates.length > 0 && (
        <Text color={TextColor.gray600} variant={TextVariant.normal}>
          {listCheckCopy.modalGoBack(candidates.length)}
        </Text>
      )}
      {requireNote && (
        <ListCheckNoteField
          label={listCheckCopy.noMatchNoteLabel}
          value={note}
          onChange={setNote}
        />
      )}
    </Modal>
  );
};

export default NoneOfTheseModal;
